import formatExperimentStatus from "../utils/formatExperimentStatus";
import type { ExperimentStatus } from "@globals";
import type { BadgeProps, MantineColor, MantineSize } from "@mantine/core";
import { Badge } from "@mantine/core";

function getExperimentStatusBadgeColor(status: ExperimentStatus): MantineColor {
  switch (status) {
    case "waiting":
      return "green";
    case "recommending":
      return "blue";
    case "error":
      return "red";
    case "configuration_changed":
      return "yellow";
    default:
      return "gray";
  }
}

export default function ExperimentStatusBadge({
  status,
  size = "sm",
  ...props
}: { status: ExperimentStatus; size?: MantineSize } & BadgeProps) {
  return (
    <Badge size={size} variant="outline" color={getExperimentStatusBadgeColor(status)} {...props} px={5} fw={600}>
      {formatExperimentStatus(status)}
    </Badge>
  );
}
